import { NoteBlock } from "../block";

export interface TableBlock extends NoteBlock {
  "table-id": string;
}

export function isTableBlock(block: NoteBlock): block is TableBlock {
  return (block as TableBlock)["table-id"] !== undefined;
}
